import { lazy } from "react";
import Loadable from "../../../layout/fullLayout/loadable/loadable";
import { Navigate } from "react-router-dom";
import { AuthorizedRoute } from "../../../router/AuthorizedRoute";
const Dashboard = Loadable(
  lazy(() =>
    import("./DashBoardRoot").then(({ DashBoardRoot }) => ({
      default: DashBoardRoot,
    }))
  )
);
export const DashboardRoutes = [
  {
    path: "/",
    exact: true,
    element: <Navigate to="/dashboard" replace />,
  },
  {
    path: "/dashboard",
    exact: true,
    element: (
      <AuthorizedRoute moduleKeys={[]} allowFullAccess>
        <Dashboard />
      </AuthorizedRoute>
    ),
  },
];
